import { environment } from 'src/environment';
import { Component, Input, OnInit } from '@angular/core';
import { FooterService } from 'src/app/core/services/footer.service';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer-link',
  templateUrl: './footer-link.component.html',
  styleUrls: ['./footer-link.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink],
})
export class FooterLinkComponent implements OnInit {

  @Input() footerKey: string;
  @Input() footerNavText: string;
  footerSlug: string;

  skinName = environment.skinName;
  constructor(private footerService: FooterService) { }

  ngOnInit(): void {
    const pageList = this.footerService.pageList || [];
    pageList.forEach((page: any) => {
      if (page.type === this.footerKey) {
        this.footerSlug = page.slug;
      }
    });
  }

}
